import env from '@maui-mf/env'
import * as featureFlags from './feature-flags'

const featureName = env.FEATURE_GTI_UX
const featureDefined = !!featureName

/*
 * Note that depending on which should be the default, the logic should change.
 *
 * If the default UX should be classic, then we only show GTI if the user specifically has
 * opted out of GTI (showClassicUI equals false).
 *
 * If the default UX should be GTI, then we show the GTI UX *unless* the user has
 * specifically opted out of GTI.
 */
const defaultShouldUseGTILayout = false

export const wantsFeature = (auth = {}) => {
  return auth.isGTI || !!(featureDefined && auth.profile?.preferences?.showClassicUI === false)
}

export const grantedFeature = (auth = {}) => {
  return auth.isGTI || !!(featureDefined && featureFlags.get(featureName))
}

export const shouldUseLayout = auth => {
  if (!auth) {
    return defaultShouldUseGTILayout
  }

  return grantedFeature(auth) && wantsFeature(auth)
}
